import React, { useEffect, useRef, useState } from "react";
import {
    DKButton,
    DKInput,
    INPUT_TYPE,
    INPUT_VIEW_DIRECTION,
    DKListPicker2,
    DKLabel,
    showLoader,
    removeLoader,
    DKIcon,
    DKIcons,
} from "deskera-ui-library";
import Utility from "../../utility/Utility";
import Tenant from "../../services/tenant";
import DataParser from "../../Helper/DataParser";
import UserManager from "../../managers/UserManager";
import IAM from "../../services/iam";
import { COUNTRIES_WITH_CURRENCIES } from "../../constants/Currencies";

export default function AddNewTenant(props) {
    const [showCurrencyPicker, setShowCurrencyPicker] = useState(false);
    const [tenantName, setTenantName] = useState("");
    const [selectedCurrency, setSelectedCurrency] = useState(null);
    const [triggerValidation, setTriggerValidation] = useState(false);
    const currencyInputDiv = useRef(null);
    const currencyInput = useRef(null);
    const [currencies, setCurrencies] = useState(null);
    const [selectedCountry, setSelectedCountry] = useState(null);

    useEffect(() => {
        if (Utility.isEmptyObject(currencies)) {
            fetchCurrencies();
        }
        // currencyInputDiv.current.onclick = () => {
        //     setShowCurrencyPicker(true);
        // };

        if (currencyInput.current.textfieldId) {
            const input = document.getElementById(currencyInput.current.textfieldId);
            if (input) {
                input.tabIndex = -1;
            }
        }

        return () => { };
    }, []);

    useEffect(() => {
        if (!Utility.isEmptyObject(currencies)) {
            const defaultCurrency = currencies.find(
                (currency) => currency.currencyCode === "USD"
            );
            setSelectedCurrency(defaultCurrency);
            const country = COUNTRIES_WITH_CURRENCIES.find((country) => country.countryCode === "US");
            setSelectedCountry(country);
        }
    }, [currencies]);

    const fetchCurrencies = () => {
        return Tenant.getCurrencyEnum().then(
            (response: any) => {
                if (response?.content?.length > 0) {
                    setCurrencies(response.content);
                }
            }, (error) => {
                setCurrencies(null);
            }
        );
    }

    const onSave = () => {
        if (Utility.isEmptyObject(tenantName)) {
            setTriggerValidation(true);
            return;
        } else {
            showLoader("Adding organization...");
            Tenant.addTenant({
                tenantName,
                currencyLookUpCode: Utility.isEmptyObject(selectedCurrency) ? "USD" : selectedCurrency.currencyCode,
                countryLookupCode: Utility.isEmptyObject(selectedCountry) ? "US" : selectedCountry.countryCode,
                userId: UserManager.getUserIamID(),
                bookBeginningStartDate: DataParser.formatDate(new Date()),
                financialStartDate: DataParser.formatDate(new Date()),
                dateFormatLookUpCode: "dd-mm-yyyy",
            }).then(
                (response: any) => {
                    if (response && response.tenantId) {
                        props?.onSave?.({ tenantName, selectedCurrency });
                        IAM.switchTenant({ tenantId: response.tenantId }).then((res) => {
                            window.location.reload();
                        });
                    }
                }
            ).finally(
                () => {
                    removeLoader();
                }
            );
        }
    };

    const onClose = () => {
        props?.onClose?.();
    };

    return (
        <div className="column parent-width">
            <div className="row parent-width">
                <div className="row">
                    <DKLabel text="New Organization" className="fw-m fs-l" />
                </div>
                <div className="row justify-content-end">
                    <DKButton
                        title="Cancel"
                        className="bg-gray1 border-m fw-m"
                        onClick={onClose}
                    />
                    <DKButton
                        title="Add"
                        className="bg-button ml-r text-white fw-m"
                        onClick={onSave}
                    />
                </div>
            </div>
            <div className="row mt-l mb-m">
                <DKInput
                    autoFocus={true}
                    type={INPUT_TYPE.TEXT}
                    className="parent-width"
                    title="Company Name"
                    required
                    value={tenantName}
                    direction={INPUT_VIEW_DIRECTION.VERTICAL}
                    onChange={(text) => {
                        setTriggerValidation(!!text);
                        setTenantName(text);
                    }}
                    canValidate={triggerValidation && Utility.isEmptyObject(tenantName)}
                />
            </div>
            <div className="row mb-m">
                <DKInput
                    title="Country"
                    type={INPUT_TYPE.DROPDOWN}
                    direction={INPUT_VIEW_DIRECTION.VERTICAL}
                    required={true}
                    className="mt-m"
                    value={selectedCountry}
                    canValidate={false}
                    onChange={(value) => { }}
                    formatter={(obj) => {
                        return obj.country;
                    }}
                    dropdownConfig={{
                        title: "Select Country",
                        allowSearch: true,
                        searchableKey: "country",
                        style: { minWidth: 230 },
                        className: "shadow-m",
                        data: COUNTRIES_WITH_CURRENCIES,
                        renderer: (index, obj) => {
                            return <DKLabel text={`${obj.country}`} />;
                        },
                        onSelect: (index, obj, rowIndex) => {
                            setSelectedCountry(obj);
                            let countryObj = currencies.find(currency=>currency.currencyCode == obj.currencyCode);
                            setSelectedCurrency(countryObj);
                            setTriggerValidation(!!countryObj);
                        },
                    }}
                />
            </div>
            <div className="row mt-l mb-m" ref={currencyInputDiv}>
                <DKInput
                    ref={currencyInput}
                    type={INPUT_TYPE.TEXT}
                    className="parent-width"
                    title="Currency"
                    required
                    readOnly
                    value={
                        selectedCurrency?.currencyName
                            ? `${selectedCurrency?.currencyName} (${selectedCurrency?.currencyCode})`
                            : "United States Dollar (USD)"
                    }
                    direction={INPUT_VIEW_DIRECTION.VERTICAL}
                    invalid={triggerValidation && Utility.isEmptyObject(selectedCurrency)}
                />
                <DKIcon
                    src={DKIcons.ic_arrow_down2}
                    style={{
                        right: 35,
                    }}
                    className="ic-s position-absolute mt-m"
                />
                {showCurrencyPicker && (
                    <DKListPicker2
                        title="Select Currency"
                        className="position-absolute z-index-3 shadow-m border-s"
                        style={{
                            top: currencyInputDiv.current.offsetTop,
                            width: currencyInputDiv.current.clientWidth,
                        }}
                        searchableKey={"currencyName"}
                        allowSearch={true}
                        data={currencies}
                        renderer={(index, currency) => {
                            return (
                                <div className="row justify-content-between p-v-xs">{`${currency.currencyName} (${currency.currencyCode})`}</div>
                            );
                        }}
                        onSelect={(index, obj) => {
                            setShowCurrencyPicker(false);
                            setSelectedCurrency(obj);
                            setTriggerValidation(!!obj);
                        }}
                        onClose={() => setShowCurrencyPicker(false)}
                    />
                )}
            </div>
            
        </div>
    );
}
